import api from "./api";
import { ChildSupportSummary } from "../models/ChildSupportSummary";
import { Matter } from "../models/Matter";

const PATH = "/api/v1/child-support";

export const ChildSupportService = {
  async getSummary(matter: Matter["_id"]): Promise<ChildSupportSummary | null> {
    const response = await api.get(`${PATH}/summary`, {
      params: { matter },
    });
    return response.data.data;
  },
};
